import { render, staticRenderFns } from "./VersionUploadImage.vue?vue&type=template&id=2dfaf4ea"
import script from "./VersionUploadImage.vue?vue&type=script&lang=js"
export * from "./VersionUploadImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports